/* LE BÂNQUET — reproductor de los videos de Emplatados
   · Nada se descarga hasta que el bloque entra en pantalla (hallazgo 31).
   · En escritorio, pasar el cursor es una ojeada: se reproduce mientras el
     cursor está encima y se detiene al salir.
   · Pulsar play es una decisión: el video queda fijado y sigue corriendo
     aunque el cursor se vaya, hasta que se pause o salga de pantalla.
   · En pantallas táctiles no hay cursor: el toque reproduce y pausa.
   · Reiniciar y sonido disponibles en ambos.                               */
(() => {
  // Misma precaución que en el carrito: una sola ejecución por página.
  if (window.__lbVideo) return;
  window.__lbVideo = true;

  const cajas = document.querySelectorAll('[data-lb-video]');
  if (!cajas.length) return;

  const tactil = window.matchMedia('(hover: none)').matches;
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const cargar = (caja) => {
    const v = caja.querySelector('video');
    if (!v || caja.dataset.lbCargado) return v;
    caja.dataset.lbCargado = '1';
    caja.querySelectorAll('source[data-src]').forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    v.load();
    v.addEventListener('error', () => caja.classList.add('lb-video--sin-soporte'), { once: true });
    return v;
  };

  /* La clase «activo» la ponen los eventos del propio video, no la
     intención de reproducir: con preload="none" el primer play() llega
     antes de que haya datos y falla en silencio, dejando la portada
     oculta sobre un recuadro negro. */
  const enlazarEstado = (caja, v) => {
    if (v.dataset.lbEstado) return;
    v.dataset.lbEstado = '1';
    v.addEventListener('playing', () => caja.classList.add('lb-video--activo'));
    v.addEventListener('pause', () => caja.classList.remove('lb-video--activo'));
    v.addEventListener('ended', () => {
      caja.classList.remove('lb-video--activo');
      if (fijado(caja)) terminar(caja);
    });
  };

  /* Uno a la vez: dos videos sonando encima del otro no se entienden, y el
     que quedaba atrás seguía corriendo sin que nadie lo mirara. */
  const detenerOtros = (caja) => {
    cajas.forEach((otra) => {
      if (otra === caja) return;
      const v = otra.querySelector('video');
      if (!v || v.paused) return;
      otra.dataset.lbFijado = '0';
      otra.classList.remove('lb-video--fijado');
      v.pause();
      v.muted = true;
      otra.classList.remove('lb-video--con-audio');
      const bs = otra.querySelector('[data-lb-sonido]');
      if (bs) {
        bs.setAttribute('aria-pressed', 'false');
        bs.setAttribute('aria-label', 'Activar el sonido');
      }
      otra.classList.remove('lb-video--activo', 'lb-video--cargando');
    });
  };

  const reproducir = (caja) => {
    const v = cargar(caja);
    if (!v) return;
    enlazarEstado(caja, v);
    caja.classList.add('lb-video--cargando');

    const lanzar = () => {
      const p = v.play();
      if (p && p.catch) {
        p.catch(() => caja.classList.remove('lb-video--cargando'));
      }
      caja.classList.remove('lb-video--cargando');
    };

    // readyState 2 = hay datos del fotograma actual; antes, play() no prende.
    if (v.readyState >= 2) lanzar();
    else v.addEventListener('canplay', lanzar, { once: true });
  };

  const pausar = (caja) => {
    const v = caja.querySelector('video');
    if (v && !v.paused) v.pause();
    caja.classList.remove('lb-video--activo', 'lb-video--cargando');
  };

  /* Fijado = el visitante pidió verlo. Se conserva en el propio nodo para
     que el observador y el cursor consulten lo mismo. */
  /* Encender o apagar el sonido deja el botón de la esquina al día: el
     icono, el estado y la etiqueta salen de aquí. */
  const sonar = (caja, encendido) => {
    const v = caja.querySelector('video');
    if (!v) return;
    v.muted = !encendido;
    caja.classList.toggle('lb-video--con-audio', encendido);
    const boton = caja.querySelector('[data-lb-sonido]');
    if (boton) {
      boton.setAttribute('aria-pressed', String(encendido));
      boton.setAttribute('aria-label', encendido ? 'Silenciar' : 'Activar el sonido');
    }
  };

  const fijado = (caja) => caja.dataset.lbFijado === '1';
  const fijar = (caja, si) => {
    caja.dataset.lbFijado = si ? '1' : '0';
    caja.classList.toggle('lb-video--fijado', si);
    const v = caja.querySelector('video');
    /* Fijado se ve una vez y para; en vista previa se repite, que es lo
       que invita a quedarse mirando. */
    if (v) v.loop = !si;
  };

  /* Ver un video entero es la única forma, junto con pulsar play en otro,
     de que el que suena se detenga. */
  const terminar = (caja) => {
    fijar(caja, false);
    sonar(caja, false);
    pausar(caja);
  };

  cajas.forEach((caja) => {
    const marco = caja.querySelector('.lb-video__marco');

    /* Escritorio: el cursor da una vista previa que termina al salir. Solo
       lo fijado sobrevive a que el cursor se vaya. */
    if (!tactil && !menosMovimiento) {
      marco.addEventListener('mouseenter', () => {
        if (fijado(caja)) return;
        /* Muda siempre: el que esté sonando sigue sonando, y esta ojeada
           lo acompaña sin pisarlo. */
        sonar(caja, false);
        reproducir(caja);
      });
      marco.addEventListener('mouseleave', () => { if (!fijado(caja)) pausar(caja); });
    }

    /* Botón central: sirve en los dos casos y es el único camino en táctil. */
    /* Dos botones comparten data-lb-play: el grande del centro, que solo
       se ve cuando está detenido, y el de la esquina. Ambos alternan. */
    caja.querySelectorAll('[data-lb-play]').forEach((boton) => {
      /* El del centro es el que dice «quiero ver esto»: arranca con
         sonido. El de la esquina solo pausa y reanuda. */
      const esCentral = boton.classList.contains('lb-video__central');
      boton.addEventListener('click', (e) => {
        e.preventDefault();
        if (fijado(caja)) {
          terminar(caja);
        } else {
          /* Aunque ya esté sonando por el cursor, el clic lo fija: eso es
             justamente lo que se pide con este botón. */
          detenerOtros(caja);
          fijar(caja, true);
          if (esCentral) sonar(caja, true);
          reproducir(caja);
        }
      });
    });

    const reiniciar = caja.querySelector('[data-lb-reiniciar]');
    if (reiniciar) {
      reiniciar.addEventListener('click', (e) => {
        e.preventDefault();
        const v = cargar(caja);
        if (!v) return;
        v.currentTime = 0;
        detenerOtros(caja);
        fijar(caja, true);
        reproducir(caja);
      });
    }

    /* El sonido arranca apagado: un video que suena solo al pasar el cursor
       es intrusivo, y los navegadores bloquean la reproducción automática
       con audio. Se enciende a petición. */
    const sonido = caja.querySelector('[data-lb-sonido]');
    if (sonido) {
      sonido.addEventListener('click', (e) => {
        e.preventDefault();
        const v = cargar(caja);
        if (!v) return;
        sonar(caja, v.muted);
        // Encender el sonido también es quedarse a verlo.
        if (!v.muted) {
          detenerOtros(caja);
          fijar(caja, true);
        }
        if (v.paused) reproducir(caja);
      });
    }
  });

  /* Carga diferida: solo se prepara lo que está en pantalla, y al salir se
     pausa para no gastar datos ni batería. */
  if ('IntersectionObserver' in window) {
    /* Umbral 0: solo se pausa cuando el bloque sale por completo. Con un
       umbral alto, un video vertical que no cabe entero en pantalla se
       pausaría solo mientras el visitante lo está mirando. */
    const obs = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => {
          if (e.isIntersecting) {
            cargar(e.target);
            if (tactil && !menosMovimiento) reproducir(e.target);
          } else {
            // Fuera de pantalla no se mira nada: se suelta también lo fijado.
            fijar(e.target, false);
            pausar(e.target);
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0 }
    );
    cajas.forEach((c) => obs.observe(c));
  } else {
    cajas.forEach(cargar);
  }
})();
